module.exports = __webpack_public_path__ + "static/media/105.a1942de2.png";